<template>

    <div class="header-static-container">

        <div class="header-static">

            <a :href="makeHref('/')" class="pointer">

                <img v-if="!isDesktop" class="foxy-static-head" src="/img/logo/fox/blue-head-white.svg">

            </a>

            <a :href="makeHref('/')" class="pointer">

                <img v-if="isDesktop" class="logo-left" src="/img/logo/large/white.svg">

            </a>

        </div>

    </div>

</template>

<script>

import I18n from '@/modules/i18n'

export default {

    name: 'header-static',

    methods: {

        makeHref(url) {
            return `/${I18n.get(this)}${url}`
        }
    }
}

</script>

<style lang="scss" scoped>

.header-static-container {
    height: 56px;
    width: 100%;
    background-color: $blue;
    display: flex;
    align-items: center;
    justify-content: center;
}

.header-static {
    height: 100%;
    width: 100%;
    max-width: 1114px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 16px;
    @media screen and (min-width: $above-tablet-length) {
        justify-content: left;
    }
}

.logo-left {
    height: 40px;
    left: 16px;
}

.foxy-static-head {
    width: 40px;
    object-fit: contain;
}


</style>
